var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.25H15.5V14.5H0.5V13.25ZM8 11.375C6.83968 11.375 5.72688 10.9141 4.90641 10.0936C4.08594 9.27312 3.625 8.16032 3.625 7V0.125H4.875V7C4.875 7.8288 5.20424 8.62366 5.79029 9.20971C6.37634 9.79576 7.1712 10.125 8 10.125C8.8288 10.125 9.62366 9.79576 10.2097 9.20971C10.7958 8.62366 11.125 7.8288 11.125 7V0.125H12.375V7C12.375 8.16032 11.9141 9.27312 11.0936 10.0936C10.2731 10.9141 9.16032 11.375 8 11.375Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineEditorIcon);
export default __webpack_public_path__ + "static/media/underline-editor-icon.86084c24d18a16780e100812da3efafb.svg";
export { ForwardRef as ReactComponent };